var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownArrowWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3801 0.946004L7.979 6.53302L2.56395 0.93161C2.08912 0.44044 1.33188 0.44044 0.857048 0.93161C0.391401 1.41328 0.391401 2.16692 0.857048 2.64859L7.11313 9.11997C7.22044 9.23728 7.35083 9.33171 7.49686 9.39644C7.57219 9.42984 7.6507 9.45489 7.73102 9.47125L7.76692 9.50839H7.979C8.28568 9.50839 8.59507 9.37836 8.82549 9.14001L15.087 2.66298C15.5527 2.18131 15.5527 1.42768 15.087 0.946004C14.6122 0.454833 13.855 0.454833 13.3801 0.946004Z",
    fill: "white",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrowWhite);
export default __webpack_public_path__ + "static/media/down-arrow-white.fc4ab2b34c22df9b6d8cae3dc6146342.svg";
export { ForwardRef as ReactComponent };